export default "https://legacy.eskolare-development.com/images/address.png";